// src/utils/date.js
// Recibe una fecha del tipo '2022-10-16 19:20:00' y devuelve según lo especificado en el config
export const toDisplayDate = (serverDate, conHora = true) => {
	const fechaConfig = {
		weekday: 'long',
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		timestyle: 'long'
	}

	const fecha = new Date(serverDate).toLocaleDateString('es-Es', fechaConfig);

	let hora = ''
	if (conHora) {
		hora = ' a las ' + new Date(serverDate).toLocaleTimeString('es-Es')
	}

	return fecha + hora
}

/**
 * Muestra fecha y hora en formato corto
 * Recibe '2022-10-16 19:20:00' y devuelve '16/10/2022 19:20'
 */
export const toDisplayDateTime = (serverDate) => {
	if (!serverDate) return '-'

	const fecha = new Date(serverDate)

	if (isNaN(fecha.getTime())) return '-'

	const dia = fecha.getDate().toString().padStart(2, '0')
	const mes = (fecha.getMonth() + 1).toString().padStart(2, '0')
	const anio = fecha.getFullYear()
	const hora = fecha.getHours().toString().padStart(2, '0')
	const minutos = fecha.getMinutes().toString().padStart(2, '0')

	return `${dia}/${mes}/${anio} ${hora}:${minutos}`
}

/**
 * Muestra solo la fecha en formato corto
 * Recibe '2022-10-16 19:20:00' y devuelve '16/10/2022'
 */
export const toDisplayDateShort = (serverDate) => {
	if (!serverDate) return '-'

	const fecha = new Date(serverDate)

	if (isNaN(fecha.getTime())) return '-'

	const dia = fecha.getDate().toString().padStart(2, '0')
	const mes = (fecha.getMonth() + 1).toString().padStart(2, '0')
	const anio = fecha.getFullYear()

	return `${dia}/${mes}/${anio}`
}